<template>
	<transition name="modal">
    <div class="modal-overlay" @click="onOverlayClick">
      <div class="modal-wrapper">
        <div class="modal-container" :style="{ maxWidth: contentWidth }">

          <div class="modal-header">
            <slot name="header">
            </slot>
            <b-button size="sm" class="p-0 m-0" variant="outline-danger" @click="$emit('close')">
              <font-awesome-icon :icon="['far', 'times']" size="lg" fixed-width/>
            </b-button>
          </div>

          <div class="modal-body">
            <slot name="body">
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="my-button modal-default-button" @click="$emit('close')">
                OK
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    contentWidth: {
      type: String,
      default: '400px'
    }
  },
  methods: {
    onOverlayClick() {
      if (this.required) {
        return
      } else {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0 43 109 / 50%);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 95vw;
  overflow: hidden;
  z-index: 9999;  /*not preventing close event from being emitted*/
  margin: 0px auto;
  padding: 10px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgb(22 40 241 / 27%);
  transition: all .3s ease;
  border-radius: 15px;
}

.modal-body {
  overflow-y: auto;
  max-height: calc(100vh - 120px);
}

.modal-header {
  display: flex;
  align-items: center;
  padding: 7px 10px;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-header .close-action {
  margin-top: 0;
  float: right;
  cursor: pointer;
}

/* .modal-body {
  text-align: center;
} */

.modal-default-button {
  float: right;
}

.modal-footer {
  display: flex;
  gap: 10px;
  padding: 2px 0px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
